bcn.carousel = (function () {

  'use strict';

  function initCounter (carousel) {

    carousel.on('init', function (event, slick) {
      if (slick.slideCount > 1) {
        var counter = '<div class="slick-count"><span class="js-current-slide">1</span> / ' + slick.slideCount + '</div>';
        carousel.append(counter);
      }
    });

    carousel.on('afterChange', function (event, slick, currentSlide) {
      $('.js-current-slide').text(currentSlide+1);
    });
  }

  function showDots (carousel) {
    return carousel.attr('data-show-slide-numbers') ? false : true;
  }

  return {
    init: function () {

      var carousel = $('[data-carousel]');

      if (!carousel.length) { return; }

      if (carousel.attr('data-show-slide-numbers')) {
        initCounter(carousel);
      }

      carousel.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        dots: showDots(carousel),
        fade: true,
        lazyLoad: 'progressive',
        nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span></button>',
        prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span></button>'
      });

    }
  };

})();
